import { memo, useCallback } from 'react'

import { ControlPointDuplicate } from '@mui/icons-material'
import { MenuItem, ListItemIcon, Typography, Skeleton, Divider } from '@mui/material'
import { OriginGateway } from '@nativewaves/nw-cloud-sdk/origin'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useGatewayDeleteMutation, useGatewayCreateMutation } from 'hooks/mutations/origin'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<OriginGateway>) => {
  const { t } = useTranslation(['common', 'entity', 'domain'])

  const { mutate: createGateway, ...gatewayCreateMutation } = useGatewayCreateMutation({ originId: row.original.id })
  const { mutate: deleteGateway } = useGatewayDeleteMutation()

  const handleDuplicateGateway = useCallback(() => {
    createGateway(
      { originGatewayInsert: row.original },
      {
        onSuccess: () => {
          onClose()
        },
      },
    )
  }, [createGateway, onClose, row.original])

  const handleDeleteGateway = useCallback(() => {
    onClose()

    setTimeout(() => {
      deleteGateway({ gatewayId: row.original.id })
    }, 300)
  }, [deleteGateway, onClose, row.original.id])

  return (
    <>
      <MenuItem onClick={handleDuplicateGateway} disabled={gatewayCreateMutation.isPending}>
        <ListItemIcon>
          <ControlPointDuplicate />
        </ListItemIcon>
        <Typography sx={{ width: '100%' }}>
          {gatewayCreateMutation.isPending ? <Skeleton variant="text" /> : t('duplicate')}
        </Typography>
      </MenuItem>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider component="li" />
      <MenuItemDelete onConfirm={handleDeleteGateway} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
